/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecureScoreDetails {
    getFixupPrototypeFunction() { return SecureScoreDetails.fixupPrototype; }

    static newInstance(model: Partial<SecureScoreDetails>): SecureScoreDetails {
        let obj = Object.assign(new SecureScoreDetails(), model);
        SecureScoreDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecureScoreDetails>): SecureScoreDetails {
        if (!model) return null;
        return SecureScoreDetails.newInstance(<SecureScoreDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecureScoreDetails) {
        if (!obj) return;

        models.SecureScoreDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecureScoreDetails): boolean {
        Object.setPrototypeOf(obj, SecureScoreDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.properties) {
            models.SecureScoreDerivedDetails.fixupPrototype(this.properties);
        }
    }

    /**
     * ID of the cloud account subscription
     */
    id: string;

    /**
     * Secure score name for azure subscription
     */
    name: string;

    /**
     * Microsoft api for secure scores
     */
    type: string;

    /**
     * Secure score value
     */
    properties: models.SecureScoreDerivedDetails;

}
